import { ROLES } from 'src/infra/Api/COL/roles.colombia'

export const getColombiaRoles = () => {
  return ROLES
}
